import { createApiConfig } from "./config";
import { COMMON_DATA_API_URL } from "./routes";

const apiConfig = createApiConfig();

export const getDashboardData = () => apiConfig.get(`/dashboard`);

export const getCommonData = () => apiConfig.get(COMMON_DATA_API_URL);